import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfigurationService } from '../../../configurationService';
import {ObjectNames, Severity, Answer} from '../../constants/constants';
import { ListService } from '../../custom/list/list.service';
import data from '../../staticJSON/inventory-template.json';

@Component({
  selector: 'app-purchase-template',
  templateUrl: './purchase-template.component.html',
  styleUrls: ['./purchase-template.component.scss']
})
export class PurchaseTemplateComponent implements OnInit {

  @Input() purchaseTemplateConfig: any;
  allPurchaseTemplates = [];


  displayEditPOTemplate1 = false;
  answertypeConstants= Answer;
  originalTemplates=[];
  purchaseTemplateDialogHeader: string='';
  availablePurchaseLabels_billing =[];
  availablePurchaseLabels_shipping =[];
  availablePurchaseLabels_misc =[];
  availablePurchaseLabels_section =[];
  availablePurchaseLabels_table =[];
  availablePurchaseLabels_footer =[];
  availablePurchaseLabels_message =[];
  availablePurchaseLabels_expense =[];
  availablePurchaseLabels_other1 =[];
  availablePurchaseLabels_other2 =[];
  availablePurchaseLabels_other3 =[];
  //View
  selectedPurchaseCheck1: boolean=false;
  selectedPurchaseCheck2: boolean=false;
  selectedPurchaseCheck3: boolean=false;
  selectedPurchaseCheck4: boolean=false;
  selectedPurchaseCheck5: boolean=false;
  selectedPurchaseCheck6: boolean=false;
  selectedPurchaseCheck7: boolean=false;
  selectedPurchaseCheck8: boolean=false;
  selectedPurchaseCheck9: boolean=false;
  selectedPurchaseCheck10: boolean=false;
  selectedPurchaseCheck11: boolean=false;
  //Print
  selectedPurchasePrintCheck1: boolean=false;
  selectedPurchasePrintCheck2: boolean=false;
  selectedPurchasePrintCheck3: boolean=false;
  selectedPurchasePrintCheck4: boolean=false;
  selectedPurchasePrintCheck5: boolean=false;
  selectedPurchasePrintCheck6: boolean=false;
  selectedPurchasePrintCheck7: boolean=false;
  selectedPurchasePrintCheck8: boolean=false;
  selectedPurchasePrintCheck9: boolean=false;
  selectedPurchasePrintCheck10: boolean=false;
  selectedPurchasePrintCheck11: boolean=false;
  displayEditPOTemplate: boolean=false;
  vendorSections =[];
  billSections=[];
  newBillSections=[];
  vendorReturnSections = [];
  itemReceiptSections=[];
  allSections = [];
  templatePOTemp  = data;
  allModules: any = [];
  inventoryObjId;
  allCustomFields = [];
  customFieldData = [];
  allCustomFieldTypes = [];
  purchaseOrderSections =[];
  sectionConfig: any;
  maxNo: boolean =false;
  maxNo1: boolean =false;
  maxNoPrint: boolean =false;
  maxNoPrint1: boolean =false;
  totalAmt: number=0;
  totalAmt1: number=0;
  totalAmtPrint: number=0;
  totalAmtPrint1: number=0;

  /** Vendor Credit */
  vendorCreditSections =[];

  constructor(private service: ConfigurationService,private customfieldService: ListService,private appMainService: AppMainService,
    private app: AppMainComponent,private titlecasePipe: TitleCasePipe,private messageService: MessageService) { }


  ngOnInit(): void {
      this.getModules();
      this.loadConfigurations('Purchase');
  }

  hideDialog() {
    this.getModules();
    this.allPurchaseTemplates= this.originalTemplates;
    this.totalAmt=0;
    this.totalAmt1=0;
    this.maxNo=false;
    this.maxNo1=false;
    this.templatePOTemp=null;
    this.purchaseOrderSections=[];
    this.vendorSections=[];
    this.vendorReturnSections =[];
    this.billSections=[];
    this.newBillSections=[];
    this.itemReceiptSections=[];
    this.availablePurchaseLabels_billing =[];
    this.availablePurchaseLabels_shipping =[];
    this.availablePurchaseLabels_misc =[];
    this.availablePurchaseLabels_section =[];
    this.availablePurchaseLabels_table =[];
    this.availablePurchaseLabels_footer =[];
    this.availablePurchaseLabels_message =[];
    this.availablePurchaseLabels_other1 =[];
    this.availablePurchaseLabels_other2 =[];
    this.availablePurchaseLabels_other3 =[];
  }

  getModules() {
    this.allModules=this.app.preLoadedObjects;
    const obj = this.allModules.filter(obj => obj.name == ObjectNames.purchaseOrderConstants.purchaseFieldName)[0];
    this.inventoryObjId = obj.id;
    this.getCustomFieldTypes(obj.id);
  }

  getCustomFieldTypes(objectId) {
    this.customfieldService.getAllCustomFieldTypes(objectId).then(fldtyps => {
      this.allCustomFieldTypes = fldtyps;
      this.loadCustomFields();
    });
  }

  loadCustomFields() {
    this.customfieldService.getAllCustomFields(this.inventoryObjId).then(fields => {
      this.customFieldData = [];
      this.allCustomFields = [];
      if (fields && fields.length > 0) {
        for (let l of fields) {
          let eachRecord = {
            id: Number(l.id + ""),
            name: l.name,
            module: this.allModules.find(el => el.id == l.objectId)?.name,
            formControl: this.allCustomFieldTypes.find(el => el.id == l.formControlId)?.name,
            formControlId: l.formControlId,
            isRequired: l.isRequired,
            statusId: l.statusId,
            statusName: l.status.name,
            section: l.section,
            configurationId: l.configurationId,
            isEdit: l.isEdit,
            isDelete: l.isDelete,
            pickupList: l.pickListValues ? JSON.stringify(l.pickListValues) : l.pickListValues
          }
          this.customFieldData.push(eachRecord);
        }
      }
      this.allCustomFields = this.customFieldData;
    });
  }

  loadConfigurations(name) {
    this.appMainService.isShowSpinner('purchase');
    this.service.getCaseConfigurations(name).subscribe(configs => {
      //templates
      this.purchaseTemplateConfig = configs.filter(s => s.name == ObjectNames.purchaseOrderConstants.Purchase_Template_Object)[0];
      if(this.purchaseTemplateConfig?.configurationDetails.length>0){
        this.allPurchaseTemplates = JSON.parse(this.purchaseTemplateConfig?.configurationDetails[0].configJSONValue);
        this.originalTemplates = JSON.parse(JSON.stringify(this.allPurchaseTemplates));
      }
      //sections
      this.sectionConfig = configs.filter(s => s.name == ObjectNames.customConstants.Purchase_Section_Object)[0];
      if(this.sectionConfig?.configurationDetails.length>0){
        this.allSections = JSON.parse(this.sectionConfig?.configurationDetails[0].configJSONValue);
        this.allSections.forEach(element => {
          element.isSelect = true;
        });
      }
      this.appMainService.isHideSpinner('purchase');
    });
  }

  showEditPOTemplate(c) {
    if(c.producttype.name == ObjectNames.purchaseOrderConstants.PurchaseOrder_Object){
      this.templatePOTemp = c;
      this.purchaseTemplateDialogHeader= ObjectNames.purchaseOrderConstants.PurchaseOrder_Object;
      this.purchaseOrderSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availablePurchaseLabels_billing = this.templatePOTemp.labels_billaddress;
      this.availablePurchaseLabels_shipping = this.templatePOTemp.labels_shipaddress;
      this.availablePurchaseLabels_misc = this.templatePOTemp.labels_misc;
      this.availablePurchaseLabels_section = this.templatePOTemp.labels_section;
      this.availablePurchaseLabels_table = this.templatePOTemp.labels_table;
      this.availablePurchaseLabels_footer = this.templatePOTemp.labels_footer;
      this.availablePurchaseLabels_message = this.templatePOTemp.labels_message;
      this.availablePurchaseLabels_other1 = this.templatePOTemp.labels_purchase_other1;
      this.availablePurchaseLabels_other2 = this.templatePOTemp.labels_purchase_other2;
      this.availablePurchaseLabels_other3 = this.templatePOTemp.labels_purchase_other3;
    }else if(c.producttype.name == ObjectNames.vendorConstants.Vendor_Object){
      this.templatePOTemp = c;
      this.purchaseTemplateDialogHeader=  ObjectNames.vendorConstants.Vendor_Title;
      this.vendorSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availablePurchaseLabels_billing = this.templatePOTemp.labels_vendor;
      this.availablePurchaseLabels_shipping = this.templatePOTemp.labels_contact;
      this.availablePurchaseLabels_misc = this.templatePOTemp.labels_address;
      this.availablePurchaseLabels_table = this.templatePOTemp.labels_businessdetails;
      this.availablePurchaseLabels_footer = this.templatePOTemp.labels_paymentdetails;
      this.availablePurchaseLabels_other1 = this.templatePOTemp.labels_vendor_other1;
      this.availablePurchaseLabels_other2 = this.templatePOTemp.labels_vendor_other2;
      this.availablePurchaseLabels_other3 = this.templatePOTemp.labels_vendor_other3;
    } else if(c.producttype.name == ObjectNames.billsConstants.Bills_Object){
      this.purchaseTemplateDialogHeader= ObjectNames.billsConstants.Payment_receipts;
      this.templatePOTemp=c;
      this.billSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availablePurchaseLabels_section = this.templatePOTemp.labels_section;
      this.availablePurchaseLabels_table = this.templatePOTemp.labels_table;
      this.availablePurchaseLabels_footer = this.templatePOTemp.labels_footer;
      this.availablePurchaseLabels_message = this.templatePOTemp.labels_message;
      this.availablePurchaseLabels_other1 = this.templatePOTemp.labels_bills_other1;
      this.availablePurchaseLabels_other2 = this.templatePOTemp.labels_bills_other2;
      this.availablePurchaseLabels_other3 = this.templatePOTemp.labels_bills_other3;
    }else if(c.producttype.name == ObjectNames.itemReceiptConstants.receipt_Object){
      this.purchaseTemplateDialogHeader= ObjectNames.itemReceiptConstants.receipt_Object;
      this.templatePOTemp=c;
      this.itemReceiptSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availablePurchaseLabels_billing = this.templatePOTemp.labels_billaddress;
      this.availablePurchaseLabels_shipping = this.templatePOTemp.labels_shipaddress;
      this.availablePurchaseLabels_section = this.templatePOTemp.labels_section;
      this.availablePurchaseLabels_misc = this.templatePOTemp.labels_misc;
      this.availablePurchaseLabels_table = this.templatePOTemp.labels_table;
      this.availablePurchaseLabels_footer = this.templatePOTemp.labels_footer;
      this.availablePurchaseLabels_message = this.templatePOTemp.labels_message;
    }else if(c.producttype.name == ObjectNames.newBillConstants.newBill_Object){
      this.purchaseTemplateDialogHeader= ObjectNames.newBillConstants.newBill_Object;
      this.templatePOTemp=c;
      this.newBillSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availablePurchaseLabels_billing = this.templatePOTemp.labels_billaddress;
      this.availablePurchaseLabels_shipping = this.templatePOTemp.labels_shipaddress;
      this.availablePurchaseLabels_misc = this.templatePOTemp.labels_misc;
      this.availablePurchaseLabels_section = this.templatePOTemp.labels_section;
      this.availablePurchaseLabels_expense = this.templatePOTemp.labels_expenses;
      this.availablePurchaseLabels_table = this.templatePOTemp.labels_table;
      this.availablePurchaseLabels_footer = this.templatePOTemp.labels_footer;
      this.availablePurchaseLabels_message = this.templatePOTemp.labels_message;
    }else if(c.producttype.name == ObjectNames.vendorReturnConstants.vendorReturn_Object){
      this.purchaseTemplateDialogHeader= ObjectNames.vendorReturnConstants.vendorReturn_Object;
      this.templatePOTemp=c;
      this.vendorReturnSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availablePurchaseLabels_billing = this.templatePOTemp.labels_billaddress;
      this.availablePurchaseLabels_shipping = this.templatePOTemp.labels_shipaddress;
      this.availablePurchaseLabels_misc = this.templatePOTemp.labels_misc;
      this.availablePurchaseLabels_section = this.templatePOTemp.labels_section;
      this.availablePurchaseLabels_table = this.templatePOTemp.labels_table;
      this.availablePurchaseLabels_footer = this.templatePOTemp.labels_footer;
      this.availablePurchaseLabels_message = this.templatePOTemp.labels_message;
      this.availablePurchaseLabels_other1 = this.templatePOTemp.labels_vendorreturns_other1;
      this.availablePurchaseLabels_other2 = this.templatePOTemp.labels_vendorreturns_other2;
      this.availablePurchaseLabels_other3 = this.templatePOTemp.labels_vendorreturns_other3;
    }else if(c.producttype.name == ObjectNames.vendorCreditConstants.vendorCredit_Object){
      this.purchaseTemplateDialogHeader= ObjectNames.vendorCreditConstants.vendorCredit_Object;
      this.templatePOTemp=c;
      this.vendorCreditSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availablePurchaseLabels_billing = this.templatePOTemp.labels_billaddress;
      this.availablePurchaseLabels_shipping = this.templatePOTemp.labels_shipaddress;
      this.availablePurchaseLabels_misc = this.templatePOTemp.labels_misc;
      this.availablePurchaseLabels_section = this.templatePOTemp.labels_section;
      this.availablePurchaseLabels_expense = this.templatePOTemp.labels_expenses;
      this.availablePurchaseLabels_table = this.templatePOTemp.labels_table;
      this.availablePurchaseLabels_footer = this.templatePOTemp.labels_footer;
      this.availablePurchaseLabels_message = this.templatePOTemp.labels_message;
      this.availablePurchaseLabels_other1 = this.templatePOTemp.labels_vendorcredit_other1;
      this.availablePurchaseLabels_other2 = this.templatePOTemp.labels_vendorcredit_other2;
      this.availablePurchaseLabels_other3 = this.templatePOTemp.labels_vendorcredit_other3;
    }
    //else {
      // this.templatePOTemp = c;
      // this.allCustomFields.forEach(fld => {
      //   let temp = {}
      //   if (fld.isEdit) {
      //     temp = {
      //       code: fld.name,
      //       id: fld.configurationId,
      //       checked: false,
      //       movable: true,
      //       isShowForDrag: true,
      //       labelname: fld.name,
      //       sectionId: fld.section.id
      //     }
      //     if (!(this.templatePOTemp.labels.some(el => (el.labelname == fld.name && el.sectionId == fld.section.id)))) {
      //       this.templatePOTemp.labels.push(temp);
      //     }
      //   }
      // });

      // this.allSections.forEach(element => {
      //   const availableFields = this.templatePOTemp.labels.filter(labelData => labelData.sectionId == element.id);
      //   const unCheckedFields = availableFields.filter(c => c.checked == false);
      //   if (availableFields.length == unCheckedFields.length) {
      //     element.isSelect = false;
      //   }
      // });
      // this.displayEditPOTemplate = true;
    //}
      //load custom fields
      this.allCustomFields?.forEach(fld => {
        if(fld.section?.typeId==this.templatePOTemp.producttypeId){
          let temp = {}
          if (fld.isEdit) {
            temp = {
              code: fld.name,
              id: fld.id,
              isChecked: false,
              formControl: fld.formControl,
              formControlId: fld.formControlId,
              isMovable: true,
              isShowForDrag: true,
              labelname: fld.name,
              name: fld.name,
              sectionId: fld.section.id,
              custom: true,
              IsHide: false,
              pickupList: fld.pickupList
            }
            const sections = (c.producttype.name == ObjectNames.purchaseOrderConstants.PurchaseOrder_Object?this.purchaseOrderSections:c.producttype.name == ObjectNames.vendorConstants.Vendor_Object?this.vendorSections :c.producttype.name == ObjectNames.vendorReturnConstants.vendorReturn_Object?this.vendorReturnSections: c.producttype.name == ObjectNames.vendorCreditConstants.vendorCredit_Object ? this.vendorCreditSections : this.billSections);
            let sectionData = sections.find(section => section.id == fld?.section?.id);
            if (sectionData) {
              if (!this.templatePOTemp[sectionData?.code]?.find(labelData => labelData.name == fld.name && labelData.sectionId == fld.section.id)) {
                this.templatePOTemp[sectionData?.code]?.push(temp);
              }
            }
          }
        }
      });
      if (this.availablePurchaseLabels_billing) {
        const item = this.availablePurchaseLabels_billing.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck1 = true;
        } else {
          this.selectedPurchaseCheck1 = false;
        }
        const print = this.availablePurchaseLabels_billing.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck1 = true;
        } else {
          this.selectedPurchasePrintCheck1 = false;
        }
      }
      if (this.availablePurchaseLabels_shipping) {
        const item = this.availablePurchaseLabels_shipping.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck2 = true;
        } else {
          this.selectedPurchaseCheck2 = false;
        }
        const print = this.availablePurchaseLabels_shipping.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck2 = true;
        } else {
          this.selectedPurchasePrintCheck2 = false;
        }
      }
      if (this.availablePurchaseLabels_misc) {
        const item = this.availablePurchaseLabels_misc.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck3 = true;
        } else {
          this.selectedPurchaseCheck3 = false;
        }
        const print = this.availablePurchaseLabels_misc.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck3 = true;
        } else {
          this.selectedPurchasePrintCheck3 = false;
        }
      }
      if (this.availablePurchaseLabels_section) {
        const item = this.availablePurchaseLabels_section.filter(i => i.isChecked == true);
        for(let s of this.availablePurchaseLabels_section){
          if(s.isChecked){
            this.totalAmt++;
          }
          if(s.IsPrint){
            this.totalAmtPrint++;
          }
        }
        if(this.totalAmt==5){
          this.maxNo =true;
        }
        if(this.totalAmtPrint==5){
          this.maxNoPrint =true;
        }
        if (item.length > 0) {
          this.selectedPurchaseCheck4 = true;
        } else {
          this.selectedPurchaseCheck4 = false;
        }
        const print = this.availablePurchaseLabels_section.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck4 = true;
        } else {
          this.selectedPurchasePrintCheck4 = false;
        }
      }
      if (this.availablePurchaseLabels_table) {
        const item = this.availablePurchaseLabels_table.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck5 = true;
        } else {
          this.selectedPurchaseCheck5 = false;
        }
        const print = this.availablePurchaseLabels_table.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck5 = true;
        } else {
          this.selectedPurchasePrintCheck5 = false;
        }
      }
      if (this.availablePurchaseLabels_expense) {
        const item = this.availablePurchaseLabels_expense.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck11 = true;
        } else {
          this.selectedPurchaseCheck11 = false;
        }
        const print = this.availablePurchaseLabels_expense.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck11 = true;
        } else {
          this.selectedPurchasePrintCheck11 = false;
        }
      }
      if (this.availablePurchaseLabels_footer) {
        const item = this.availablePurchaseLabels_footer.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck6 = true;
        } else {
          this.selectedPurchaseCheck6 = false;
        }
        const print = this.availablePurchaseLabels_footer.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck6 = true;
        } else {
          this.selectedPurchasePrintCheck6 = false;
        }
      }
      if (this.availablePurchaseLabels_message) {
        const item = this.availablePurchaseLabels_message.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck7 = true;
        } else {
          this.selectedPurchaseCheck7 = false;
        }
        const print = this.availablePurchaseLabels_message.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck7 = true;
        } else {
          this.selectedPurchasePrintCheck7 = false;
        }
      }
      if (this.availablePurchaseLabels_other1) {
        const item = this.availablePurchaseLabels_other1.filter(i => i.isChecked == true);
        for(let s of this.availablePurchaseLabels_other1){
          if(s.isChecked){
            this.totalAmt1++;
          }
          if(s.IsPrint){
            this.totalAmtPrint1++;
          }
        }
        if(this.totalAmt1==5){
          this.maxNo1 =true;
        }
        if(this.totalAmtPrint1==5){
          this.maxNoPrint1 =true;
        }
        if (item.length > 0) {
          this.selectedPurchaseCheck8 = true;
        } else {
          this.selectedPurchaseCheck8 = false;
        }
        const print = this.availablePurchaseLabels_other1.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck8 = true;
        } else {
          this.selectedPurchasePrintCheck8 = false;
        }
      }
      if (this.availablePurchaseLabels_other2) {
        const item = this.availablePurchaseLabels_other2.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck9 = true;
        } else {
          this.selectedPurchaseCheck9 = false;
        }
        const print = this.availablePurchaseLabels_other2.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck9 = true;
        } else {
          this.selectedPurchasePrintCheck9 = false;
        }
      }
      if (this.availablePurchaseLabels_other3) {
        const item = this.availablePurchaseLabels_other3.filter(i => i.isChecked == true);
        if (item.length > 0) {
          this.selectedPurchaseCheck10 = true;
        } else {
          this.selectedPurchaseCheck10 = false;
        }
        const print = this.availablePurchaseLabels_other3.filter(i => i.IsPrint == true);
        if (print.length > 0) {
          this.selectedPurchasePrintCheck10 = true;
        } else {
          this.selectedPurchasePrintCheck10 = false;
        }
      }
      this.displayEditPOTemplate1 = true;
  }

  selectedPurchaseRow1(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_billing) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_billing) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_billing) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_billing) {
          if (s.isMovable == true) {
            s.IsPrint = false;
          }
        }
      }
    }
  }

  selectedPurchaseRow2(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_shipping) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_shipping) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_shipping) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_shipping) {
          if (s.isMovable == true) {
            s.IsPrint = false;
          }
        }
      }
    }
  }

  selectedPurchaseRow3(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_misc) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_misc) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_misc) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_misc) {
          if (s.isMovable == true) {
            s.IsPrint = false;
          }
        }
      }
    }
  }

  selectedPurchaseRow4(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_section) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_section) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_section) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_section) {
          if (s.isMovable == true) {
            s.IsPrint = false;
          }
        }
      }
    }
  }

  selectedPurchaseRow5(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_table) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_table) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_table) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_table) {
          if (s.isMovable == true) {
            s.IsPrint = false;
          }
        }
      }
    }
  }

  selectedPurchaseRow6(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_footer) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_footer) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_footer) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_footer) {
          if (s.isMovable == true) {
            s.IsPrint = false;
          }
        }
      }
    }
  }

  selectedPurchaseRow7(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_message) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_message) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_message) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_message) {
          if (s.isMovable == true) {
            s.IsPrint = false;
          }
        }
      }
    }
  }

  selectedPurchaseRow8(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_other1) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_other1) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_other2) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_other2) {
          if (s.isMovable == true) {
            s.IsPrint = false;
          }
        }
      }
    }
  }

  selectedPurchaseRow9(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_other2) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_other2) {
          s.IsPrint = true;
        }
      }
    } else {
     if(type=='view'){
      for (let s of this.availablePurchaseLabels_other2) {
        if (s.isMovable == true) {
          s.isChecked = false;
        }
      }
     }else{
      for (let s of this.availablePurchaseLabels_other2) {
        if (s.isMovable == true) {
          s.IsPrint = false;
        }
      }
     }
    }
  }

  selectedPurchaseRow10(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_other3) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_other3) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_other3) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_other3) {
          if (s.isMovable == true) {
            s.IsPrint= false;
          }
        }
      }
    }
  }

  selectedPurchaseRow11(value,type) {
    if (value) {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_expense) {
          s.isChecked = true;
        }
      }else{
        for (let s of this.availablePurchaseLabels_expense) {
          s.IsPrint = true;
        }
      }
    } else {
      if(type=='view'){
        for (let s of this.availablePurchaseLabels_expense) {
          if (s.isMovable == true) {
            s.isChecked = false;
          }
        }
      }else{
        for (let s of this.availablePurchaseLabels_expense) {
          if (s.isMovable == true) {
            s.IsPrint= false;
          }
        }
      }
    }
  }

  setBillingSection(value,type){
    if(type=='view'){
      if (value) {
        this.selectedPurchaseCheck1 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_billing.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_billing.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_billing.length == checkedFields.length) {
          this.selectedPurchaseCheck1 = true;
        } else if (!value && this.availablePurchaseLabels_billing.length == unCheckedFields.length) {
          this.selectedPurchaseCheck1 = false;
        }
      }
    }else{
      if (value) {
        this.selectedPurchasePrintCheck1 = true;
      } else {
        const printFields = this.availablePurchaseLabels_billing.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_billing.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_billing.length == printFields.length) {
          this.selectedPurchasePrintCheck1 = true;
        } else if (!value && this.availablePurchaseLabels_billing.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck1 = false;
        }
      }
    }
  }

  setShippingSection(value,type){
    if(type=='view'){
      if (value) {
        this.selectedPurchaseCheck2 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_shipping.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_shipping.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_shipping.length == checkedFields.length) {
          this.selectedPurchaseCheck2 = true;
        } else if (!value && this.availablePurchaseLabels_shipping.length == unCheckedFields.length) {
          this.selectedPurchaseCheck2 = false;
        }
      }
    }else{
      if (value) {
        this.selectedPurchasePrintCheck2 = true;
      } else {
        const printFields = this.availablePurchaseLabels_shipping.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_shipping.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_shipping.length == printFields.length) {
          this.selectedPurchasePrintCheck2 = true;
        } else if (!value && this.availablePurchaseLabels_shipping.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck2 = false;
        }
      }
    }
  }

  setMiscSection(value,type){
    if(type=='view'){
      if (value) {
        this.selectedPurchaseCheck3 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_misc.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_misc.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_misc.length == checkedFields.length) {
          this.selectedPurchaseCheck3 = true;
        } else if (!value && this.availablePurchaseLabels_misc.length == unCheckedFields.length) {
          this.selectedPurchaseCheck3 = false;
        }
      }
    }else{
      if (value) {
        this.selectedPurchasePrintCheck3 = true;
      } else {
        const printFields = this.availablePurchaseLabels_misc.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_misc.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_misc.length == printFields.length) {
          this.selectedPurchasePrintCheck3 = true;
        } else if (!value && this.availablePurchaseLabels_misc.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck3 = false;
        }
      }
    }
  }

  setSectionSection(value,type){
    if(type=='view'){
      if (value) this.totalAmt++;
      else this.totalAmt--;
      this.totalAmt === 5 ? (this.maxNo = true) : (this.maxNo = false);
      if (value) {
        this.selectedPurchaseCheck4 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_section.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_section.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_section.length == checkedFields.length) {
          this.selectedPurchaseCheck4 = true;
        } else if (!value && this.availablePurchaseLabels_section.length == unCheckedFields.length) {
          this.selectedPurchaseCheck4 = false;
        }
      }
    }else{
      if (value) this.totalAmtPrint++;
      else this.totalAmtPrint--;
      this.totalAmtPrint === 5 ? (this.maxNoPrint = true) : (this.maxNoPrint = false);
      if (value) {
        this.selectedPurchasePrintCheck4 = true;
      } else {
        const printFields = this.availablePurchaseLabels_section.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_section.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_section.length == printFields.length) {
          this.selectedPurchasePrintCheck4 = true;
        } else if (!value && this.availablePurchaseLabels_section.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck4 = false;
        }
      }
    }
  }

  setTableSection(value,type){
    if(type=='view'){
      if (value) {
        this.selectedPurchaseCheck5 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_table.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_table.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_table.length == checkedFields.length) {
          this.selectedPurchaseCheck5 = true;
        } else if (!value && this.availablePurchaseLabels_table.length == unCheckedFields.length) {
          this.selectedPurchaseCheck5 = false;
        }
      }
    }else{
      if (value) {
        this.selectedPurchasePrintCheck5 = true;
      } else {
        const printFields = this.availablePurchaseLabels_table.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_table.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_table.length == printFields.length) {
          this.selectedPurchasePrintCheck5 = true;
        } else if (!value && this.availablePurchaseLabels_table.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck5 = false;
        }
      }
    }

  }

  setExpenseSection(value,type){
    if(type == 'view'){
      if (value) {
        this.selectedPurchaseCheck11 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_expense.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_expense.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_expense.length == checkedFields.length) {
          this.selectedPurchaseCheck11 = true;
        } else if (!value && this.availablePurchaseLabels_expense.length == unCheckedFields.length) {
          this.selectedPurchaseCheck11 = false;
        }
      }
    }else{
        if (value) this.totalAmtPrint++;
        else this.totalAmtPrint--;
        this.totalAmtPrint === 5 ? (this.maxNoPrint = true) : (this.maxNoPrint = false);
        if (value) {
          this.selectedPurchasePrintCheck11 = true;
        } else {
          const printFields = this.availablePurchaseLabels_expense.filter(c => c.IsPrint == true);
          const unPrintFields = this.availablePurchaseLabels_expense.filter(c => c.IsPrint == false);
          if (value && this.availablePurchaseLabels_expense.length == printFields.length) {
            this.selectedPurchasePrintCheck11 = true;
          } else if (!value && this.availablePurchaseLabels_expense.length == unPrintFields.length) {
            this.selectedPurchasePrintCheck11 = false;
          }
        }
      }
  }

  setFooterSection(value,type){
    if(type=='view'){
      if (value) {
        this.selectedPurchaseCheck6 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_footer.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_footer.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_footer.length == checkedFields.length) {
          this.selectedPurchaseCheck6 = true;
        } else if (!value && this.availablePurchaseLabels_footer.length == unCheckedFields.length) {
          this.selectedPurchaseCheck6 = false;
        }
      }
    }else{
      if (value) {
        this.selectedPurchasePrintCheck6 = true;
      } else {
        const printFields = this.availablePurchaseLabels_footer.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_footer.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_footer.length == printFields.length) {
          this.selectedPurchasePrintCheck6 = true;
        } else if (!value && this.availablePurchaseLabels_footer.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck6 = false;
        }
      }
    }

  }

  setMessageSection(value,type){
    if(type=='view'){
      if (value) {
        this.selectedPurchaseCheck7 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_message.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_message.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_message.length == checkedFields.length) {
          this.selectedPurchaseCheck7 = true;
        } else if (!value && this.availablePurchaseLabels_message.length == unCheckedFields.length) {
          this.selectedPurchaseCheck7 = false;
        }
      }
    }else{
      if (value) {
        this.selectedPurchasePrintCheck7 = true;
      } else {
        const printFields = this.availablePurchaseLabels_message.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_message.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_message.length == printFields.length) {
          this.selectedPurchasePrintCheck7 = true;
        } else if (!value && this.availablePurchaseLabels_message.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck7 = false;
        }
      }
    }

  }

   setOther1Section(value,type){
     if(type=='view'){
      if (value) this.totalAmt1++;
      else this.totalAmt1--;
      this.totalAmt1 === 5 ? (this.maxNo1 = true) : (this.maxNo1 = false);
      if (value) {
        this.selectedPurchaseCheck8 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_other1.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_other1.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_other1.length == checkedFields.length) {
          this.selectedPurchaseCheck8 = true;
        } else if (!value && this.availablePurchaseLabels_other1.length == unCheckedFields.length) {
          this.selectedPurchaseCheck8 = false;
        }
      }
     }else{
      if (value) this.totalAmtPrint1++;
      else this.totalAmtPrint1--;
      this.totalAmtPrint1 === 5 ? (this.maxNoPrint1 = true) : (this.maxNoPrint1 = false);
      if (value) {
        this.selectedPurchasePrintCheck8 = true;
      } else {
        const printFields = this.availablePurchaseLabels_other1.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_other1.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_other1.length == printFields.length) {
          this.selectedPurchasePrintCheck8 = true;
        } else if (!value && this.availablePurchaseLabels_other1.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck8 = false;
        }
      }
     }

  }

  setOther2Section(value,type){
    if(type=='view'){
      if (value) {
        this.selectedPurchaseCheck9 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_other2.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_other2.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_other2.length == checkedFields.length) {
          this.selectedPurchaseCheck9 = true;
        } else if (!value && this.availablePurchaseLabels_other2.length == unCheckedFields.length) {
          this.selectedPurchaseCheck9 = false;
        }
      }
    }else{
      if (value) {
        this.selectedPurchasePrintCheck9 = true;
      } else {
        const printFields = this.availablePurchaseLabels_other2.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_other2.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_other2.length == printFields.length) {
          this.selectedPurchasePrintCheck9 = true;
        } else if (!value && this.availablePurchaseLabels_other2.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck9 = false;
        }
      }
    }

  }

  setOther3Section(value,type){
    if(type=='view'){
      if (value) {
        this.selectedPurchaseCheck10 = true;
      } else {
        const checkedFields = this.availablePurchaseLabels_other3.filter(c => c.isChecked == true);
        const unCheckedFields = this.availablePurchaseLabels_other3.filter(c => c.isChecked == false);
        if (value && this.availablePurchaseLabels_other3.length == checkedFields.length) {
          this.selectedPurchaseCheck10 = true;
        } else if (!value && this.availablePurchaseLabels_other3.length == unCheckedFields.length) {
          this.selectedPurchaseCheck10 = false;
        }
      }
    }else{
      if (value) {
        this.selectedPurchasePrintCheck10 = true;
      } else {
        const printFields = this.availablePurchaseLabels_other3.filter(c => c.IsPrint == true);
        const unPrintFields = this.availablePurchaseLabels_other3.filter(c => c.IsPrint == false);
        if (value && this.availablePurchaseLabels_other3.length == printFields.length) {
          this.selectedPurchasePrintCheck10 = true;
        } else if (!value && this.availablePurchaseLabels_other3.length == unPrintFields.length) {
          this.selectedPurchasePrintCheck10 = false;
        }
      }
    }

  }

  showSection(section) {
    const fieldsAvailable = this.templatePOTemp.labels.filter(s => s.sectionId == section.id);
    if (fieldsAvailable.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  selectedSectionRow(value, section) {
    const fieldsAvailable = this.templatePOTemp.labels.filter(s => s.sectionId == section.id);
    if (value) {
      for (let s of fieldsAvailable) {
        s.checked = true;
      }
    } else {
      for (let s of fieldsAvailable) {
        if (s.movable == true) {
          s.checked = false;
        }
      }
    }
  }

  updatePOTemplate(template){
    this.templatePOTemp.updatedDate = new Date().toISOString();
    this.templatePOTemp.updatedBy = this.app.userId;
    this.templatePOTemp.updatedSource = this.app.userIP;
    this.allPurchaseTemplates.forEach(element => {
      if (template.id == element.id) {
        element = this.templatePOTemp;
      }
    });

    this.purchaseTemplateConfig.configJSONValue = JSON.stringify(this.allPurchaseTemplates);
    this.service.updateConfiguration(this.purchaseTemplateConfig).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Template updated successfully...' });
      this.displayEditPOTemplate1 = false;
      this.loadConfigurations('Purchase');
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  setLabelOnSection(value) {
    const filteredSection = this.allSections.filter(s => s.id == value.sectionId)[0];
    if (value.checked) {
      filteredSection.isSelect = true;
    } else {
      const availableFields = this.templatePOTemp.labels.filter(f => f.sectionId == value.sectionId);
      const checkedFields = availableFields.filter(c => c.checked == true);
      const unCheckedFields = availableFields.filter(c => c.checked == false);
      if (value.checked && availableFields.length == checkedFields.length) {
        filteredSection.isSelect = true;
      } else if (!value.checked && availableFields.length == unCheckedFields.length) {
        filteredSection.isSelect = false;
      }
    }
  }

}
